<div class="bubble-wrap">
  <div class="bubble" [class.bubble--flipped]="flipped"  [class.bubble--two-way]="twoWay" dir="auto">
    {{text}}
  </div>
</div>
